<template>
  <div
    class="toast-stack"
    aria-live="polite"
  >
    <transition-group name="toast-slide">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="toast-item"
        :class="`toast-item--${t.type}`"
        @click="remove(t.id)"
      >
        <svg
          class="toast-icon"
          viewBox="0 0 20 20"
          fill="none"
        >
          <circle
            v-if="t.type === 'success'"
            cx="10"
            cy="10"
            r="8"
            stroke="currentColor"
            stroke-width="1.6"
          />
          <path
            v-if="t.type === 'success'"
            d="M7 10l2 2 4-4"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            v-if="t.type === 'error'"
            cx="10"
            cy="10"
            r="8"
            stroke="currentColor"
            stroke-width="1.6"
          />
          <path
            v-if="t.type === 'error'"
            d="M10 6v4M10 14h.01"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          />
          <circle
            v-if="t.type === 'info'"
            cx="10"
            cy="10"
            r="8"
            stroke="currentColor"
            stroke-width="1.6"
          />
          <path
            v-if="t.type === 'info'"
            d="M10 9v5M10 7h.01"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          />
        </svg>
        <span class="toast-msg">{{ t.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastBus } from '../toastBus'

export default {
  name: 'ToastNotification',
  data() {
    return { toasts: [], nextId: 0 }
  },
  mounted() {
    toastBus.on('show', this.add)
  },
  beforeUnmount() {
    toastBus.off('show', this.add)
  },
  methods: {
    add({ message, type = 'error', duration = 4000 }) {
      const id = this.nextId++
      this.toasts.push({ id, message, type })
      setTimeout(() => this.remove(id), duration)
    },
    remove(id) {
      this.toasts = this.toasts.filter(t => t.id !== id)
    }
  }
}
</script>

<style scoped>
.toast-stack {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.toast-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 12px;
  font-family: "Inter", system-ui, sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  min-width: 260px;
  max-width: 380px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.06);
  cursor: pointer;
  pointer-events: all;
  line-height: 1.4;
}

.toast-item--error   { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }
.toast-item--success { background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0; }
.toast-item--info    { background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe; }

.toast-icon { width: 18px; height: 18px; flex-shrink: 0; }
.toast-msg  { flex: 1; }

.toast-slide-enter-active { transition: all 0.25s ease; }
.toast-slide-leave-active { transition: all 0.2s ease; }
.toast-slide-enter-from   { opacity: 0; transform: translateY(12px) scale(0.96); }
.toast-slide-leave-to     { opacity: 0; transform: translateX(20px) scale(0.96); }
</style>
